import React from "react";
import { BLOCKED_REQUESTS_LIMIT } from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import getBlockedRequestStore from "../../../../stores/developer-store/blocked-requests";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../../core/et3-div";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const BlockedRequestsForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const limitOptions = BLOCKED_REQUESTS_LIMIT;
  const limit = getBlockedRequestStore().limit.get();

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={limitOptions}
          onChoose={(value: TEt3PickerSingleValue) => {
            return getBlockedRequestStore().setLimit(value);
          }}
          value={limit}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          getBlockedRequestStore().getBlockedRequests();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});

export default BlockedRequestsForm;
